module.exports = __webpack_public_path__ + "img/dessert.406162f0.svg";